import React from 'react';
import { TextField, Button, Box, Grid, Typography } from '@mui/material';
import { FormData } from '../types';

interface CompanyInfoStepProps {
  data: Partial<FormData>;
  updateData: (data: Partial<FormData>) => void;
  onNext: () => void;
}

const industries = [
  'Manufacturing',
  'Retail',
  'Technology',
  'Healthcare',
  'Finance',
  'Education',
  'Other',
];

const countries = [
  'United States',
  'United Kingdom',
  'Canada',
  'Australia',
  'Germany',
  'France',
  'Other',
];

export const CompanyInfoStep: React.FC<CompanyInfoStepProps> = ({ data, updateData, onNext }) => {
  const [errors, setErrors] = React.useState<Record<string, string>>({});

  const validate = () => {
    const newErrors: Record<string, string> = {};
    if (!data.companyName?.trim()) {
      newErrors.companyName = 'Company name is required';
    }
    if (!data.industry) {
      newErrors.industry = 'Industry is required';
    }
    if (!data.country) {
      newErrors.country = 'Country is required';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = (e: React.FormEvent) => {
    e.preventDefault();
    if (validate()) {
      onNext();
    }
  };

  return (
    <Box component="form" onSubmit={handleNext}>
      <Typography variant="h6" gutterBottom>
        Company Information
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Company Name"
            name="companyName"
            value={data.companyName || ''}
            onChange={(e) => updateData({ companyName: e.target.value })}
            error={!!errors.companyName}
            helperText={errors.companyName}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            select
            fullWidth
            label="Industry"
            name="industry"
            value={data.industry || ''}
            onChange={(e) => updateData({ industry: e.target.value })}
            SelectProps={{ native: true }}
            error={!!errors.industry}
            helperText={errors.industry}
            required
          >
            <option value="">Select an industry</option>
            {industries.map((industry) => (
              <option key={industry} value={industry}>
                {industry}
              </option>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            select
            fullWidth
            label="Country"
            name="country"
            value={data.country || ''}
            onChange={(e) => updateData({ country: e.target.value })}
            SelectProps={{ native: true }}
            error={!!errors.country}
            helperText={errors.country}
            required
          >
            <option value="">Select a country</option>
            {countries.map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </TextField>
        </Grid>
      </Grid>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
        <Button variant="contained" type="submit">
          Next
        </Button>
      </Box>
    </Box>
  );
};

